import { Link } from 'react-router-dom';
import { Progress } from '@/components/ui/progress';
import { BookOpen, CheckCircle, Clock } from 'lucide-react';
import { useFeatureToggles } from '../FeatureToggleProvider';

interface Props {
  totalModules: number;
  completedModules: number;
  inProgressModules: number;
}

export default function TrainingProgressSection({ totalModules, completedModules, inProgressModules }: Props) {
  const { isRouteEnabled } = useFeatureToggles();
  const pct = totalModules > 0 ? Math.round((completedModules / totalModules) * 100) : 0;

  if (!isRouteEnabled('/modules')) return null;

  return (
    <div className="bg-card border border-border rounded-lg p-5">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">Training Progress</h2>
        <Link to="/modules" className="text-xs text-primary hover:underline">View all →</Link>
      </div>
      <div className="mb-3">
        <div className="flex justify-between text-sm mb-2">
          <span className="text-muted-foreground">Overall completion</span>
          <span className="text-foreground font-medium">{pct}%</span>
        </div>
        <Progress value={pct} className="h-2" />
      </div>
      <div className="grid grid-cols-3 gap-3 mt-4">
        <div className="text-center">
          <CheckCircle className="w-4 h-4 mx-auto mb-1 text-green-500" />
          <p className="text-lg font-bold text-foreground">{completedModules}</p>
          <p className="text-xs text-muted-foreground">Completed</p>
        </div>
        <div className="text-center">
          <Clock className="w-4 h-4 mx-auto mb-1 text-amber-400" />
          <p className="text-lg font-bold text-foreground">{inProgressModules}</p>
          <p className="text-xs text-muted-foreground">In Progress</p>
        </div>
        <div className="text-center">
          <BookOpen className="w-4 h-4 mx-auto mb-1 text-muted-foreground" />
          <p className="text-lg font-bold text-foreground">{totalModules}</p>
          <p className="text-xs text-muted-foreground">Total</p>
        </div>
      </div>
    </div>
  );
}
